import factory from './icon';
import StarSvg from './glyphs/star.svg';
import StarOutlineSvg from './glyphs/star-outline.svg';
import StarHalfSvg from './glyphs/star-half.svg';

export const Star = factory(StarSvg);
export const StarOutline = factory(StarOutlineSvg);
export const HalfStar = factory(StarHalfSvg);
